/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import ApiError from '../services/g17eco/ApiError';
import { AxiosError } from 'axios';
import { API } from '../constants/errors';
import { showPermissionDenied } from './auth';
import { showLogin } from './login';

type SupportedErrorTypes = ApiError | AxiosError;
const isNetWorkError = (e: Error) => e.message === 'Network Error';

export const getSubmitErrorMessage = (e: Error, files: unknown[]) => {
  if (!isNetWorkError(e)) {
    return e.message;
  }

  // Deal with network error
  const fileMsg = files.length > 0 ? ', and ensure any files that you are uploading are closed.' : '.';
  return e.message + '. Please check your internet connection is stable' + fileMsg;
}

export const getSafeErrorMessage = (error: SupportedErrorTypes) => {
  if (isNetWorkError(error)) {
    return error.message;
  }

  return 'safe' in error && error.safe ? error.message : API.GENERIC;
};

export const handleError = (dispatch?: any, type?: string) => (error: SupportedErrorTypes) => {

  if (dispatch) {
    if ('response' in error) {
      const status = error.response?.status;
      if (status === 401) {
        showLogin();
      }
      if (status === 403) {
        dispatch(showPermissionDenied());
      }
    }

    if (type) {
      dispatch({ type, errorMessage: getSafeErrorMessage(error) });
    }
  }
  return {
    success: false,
    message: getSafeErrorMessage(error)
  }
};
